import React from 'react';
import { Form, Card } from 'semantic-ui-react';

import Field from '../../../Field';
import RemovePassengerLabel from '../../../RemovePassengerLabel';

const Passenger = ({
  errors,
  touched,
  passenger,
  index,
  onBlur,
  onPassengerChange,
  onRemovePassenger,
  passengerTicketId
}) => (
  <Card fluid className={`anchor-passengers-${index}`}>
    <Card.Content>
      {onRemovePassenger &&
        passengerTicketId !== passenger.id && (
          <RemovePassengerLabel
            passenger={passenger}
            handleRemovePassenger={onRemovePassenger}
          />
        )}
      <Form.Group widths="equal">
        <Field
          error={errors && errors.passengerFirstName}
          touched={touched && touched.passengerFirstName}
        >
          <Form.Input
            name="passengerFirstName"
            label="Name *"
            placeholder="Name"
            value={passenger.passengerFirstName}
            onChange={onPassengerChange.bind(this, passenger.id)}
            onBlur={onBlur.bind(
              this,
              `passengers[${index}].passengerFirstName`
            )}
          />
        </Field>
        <Field
          error={errors && errors.passengerLastName}
          touched={touched && touched.passengerLastName}
        >
          <Form.Input
            name="passengerLastName"
            label="Surname *"
            placeholder="Surname"
            value={passenger.passengerLastName}
            onChange={onPassengerChange.bind(this, passenger.id)}
            onBlur={onBlur.bind(
              this,
              `passengers[${index}].passengerLastName`
            )}
          />
        </Field>
      </Form.Group>
    </Card.Content>
  </Card>
);

export default Passenger;



// WEBPACK FOOTER //
// ./src/component/tasks/CorrectClaimTask/Form/Passenger.js